module.exports = __webpack_public_path__ + "static/media/dot.067a4654.svg";